import React, {Fragment, Suspense} from 'react';
import '../../Legacy/assets/legacy.css';
import LegacyFrame from "../../Legacy/LegacyFrame";

class LegacyAttendanceReport extends React.Component {

    render() {
        return (
            <LegacyFrame withHeader={true} pageTitle={"Attendance Report" } formname={"table_78"} customClass={"field-customization-container"} />
        );
    }
}

export default LegacyAttendanceReport;